import React from 'react';
import l from "components/util/l";
import "styles/css/agent/Contacting.css";

const PortalTemplateRequestedView = () => {
  return (
    <div className="container-fluid agent-contacting-container">
      <div className="row justify-content-center align-items-center min-vh-80">
        <div>
          <div className="card border-0 bg-dark-opaque animate__animated animate__fadeIn"
            style={{ maxWidth: '36rem' }}>
            <div className="card-body p-7 text-center d-flex flex-column align-items-center justify-content-center">
              <div className="mb-4 animate__animated animate__zoomIn">
                <i className="fas fa-check-circle text-success" style={{fontSize: '5rem'}}></i>
              </div>
              
              <h1 className="display-4 font-weight-bold text-white mb-2 animate__animated animate__fadeInDown">
                {l("¡Gracias por tu interés!%PA306")}
              </h1>
              
              <div className="lead text-light animate__animated animate__fadeInUp">
                <p className="mb-3">
                  {l("En breve te contactaremos para darte seguimiento y ayudarte a crear tu agente ideal.%PA308")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PortalTemplateRequestedView;